import { PAUSE } from 'redux-persist';
import type { AnyAction } from '@reduxjs/toolkit';

interface HelpersState {
  readonly paused: boolean;
}

const initialState: HelpersState = {
  paused: false,
};

export default (state = initialState, action: AnyAction = null) => {
  switch (action.type) {
    case PAUSE: {
      return {
        ...state,
        paused: true,
      };
    }

    default:
      return state;
  }
};
